"use strict";

import angular from "angular";

import template from "./chart-column-range.component.html";
import "./themes/chart-column-range.component-dark.scss";
import "./themes/chart-column-range.component.scss";

import _ from "lodash";
import { Point } from "../../../gateway/Point/Point";
import { PointCalculated } from "../../../gateway/PointCalculated/PointCalculated";
import { Serie } from "../../../gateway/Serie/Serie";
import { ComparationStructures } from "../../../presentation/adpters/HighchartsFormaterStrutureAdapter/ComparationStructures";
import { CalculatingMachine } from "../../../presentation/services/CalculatingMachine/CalculatingMachine";

import { ColorService } from "../../../presentation/services/ColorService/ColorService";
import { NormalizeString } from "../../../utils/normalize-string/NormalizeString";

class ChartColumnRangeComponent {
    constructor($stateParams, ThemesService) {
        this.$stateParams = $stateParams;

        this.ColorService = new ColorService({ ThemesService: ThemesService });

        this.SerieDomain = new Serie();
        this.PointCalculatedDomain = new PointCalculated();
        this.PointDomain = new Point();

        this.CalculatingMachine = new CalculatingMachine({
            Serie: this.SerieDomain,
            Point: this.PointDomain,
            PointCalculated: this.PointCalculatedDomain
        });

        this.companyId = this.$stateParams.id;

        this.visualization = {};
        this.customStructure = true;
    }

    $onInit() {
        this._setVisualization();
    }

    $onChanges(changes) {
        if (
            _.get(changes, "points.previousValue") &&
            _.get(changes, "series.previousValue")
        ) {
            this._setVisualization();
        }

        if (
            !_.isEmpty(_.get(changes, "currentComparation.previousValue")) ||
            _.get(changes, "series.currentValue.length")
        ) {
            this._setVisualization();
        }
    }

    _getLast(name) {
        const serie = _.find(this.series, { name });
        if (!serie) return;
        const point = _.findLast(this.points, { s: serie._id });

        return {
            v: _.get(point, "m.v") || 0,
            name: serie.name
        };
    }

    _setDefaultVisualization() {
        this.customStructure = true;

        const _chekIsZeroNegative = (value) => {
            return value.toString()[0] == "-" && value.toString()[1] == "0"
                ? Math.abs(value)
                : value;
        };

        try {
            const financialCycle = this._getLast("Ciclo Financeiro"),
                operatingCycle = this._getLast("Ciclo Operacional"),
                apd = this._getLast("PMP"),
                ard = this._getLast("PMR"),
                asd = this._getLast("PME");
            if (!financialCycle) return;
            let isNegativeCycle = _chekIsZeroNegative(financialCycle.v);

            const deadlinesAndCycles = [
                0,
                apd.v,
                asd.v,
                ard.v + Math.abs(asd.v),
                apd.v,
                operatingCycle.v
            ];

            const label = {
                PMP: apd.v,
                PME: asd.v,
                PMR: ard.v + Math.abs(asd.v),
                CF: isNegativeCycle
            };

            const seriesLabels = {
                PMP: {
                    abrev: "PMP",
                    title: "Prazo Médio de Pagamento (PMP)",
                    labelValue: apd.v.toFixed(0)
                },
                PME: {
                    abrev: "PME",
                    title: "Prazo Médio de Estocagem (PME)",
                    labelValue: asd.v.toFixed(0)
                },
                PMR: {
                    abrev: "PMR",
                    title: "Prazo Médio de Recebimento (PMR)",
                    labelValue: ard.v.toFixed(0)
                },
                "CICLO FINANCEIRO": {
                    abrev: "CF",
                    title: "Ciclo Financeiro",
                    labelValue: isNegativeCycle.toFixed(0)
                },
                "CICLO OPERACIONAL": {
                    abrev: "CO",
                    title: "Ciclo Operacional",
                    labelValue: operatingCycle.v.toFixed(0)
                }
            };

            const series = this._getComparations(this.series);

            this.seriesProps = series.map((serie) => {
                return {
                    ...serie,
                    ...seriesLabels[
                        NormalizeString.normalizeUpperCaseNd(serie.name)
                    ]
                };
            });

            let data = [
                {
                    low: 0,
                    high: _.nth(deadlinesAndCycles, 1),
                    label: apd.v,
                    name: apd.name,
                    color: this.ColorService.colorByPath("cyan.medium")
                },
                {
                    low: 0,
                    high: _.nth(deadlinesAndCycles, 2),
                    label: asd.v,
                    name: asd.name,
                    color: this.ColorService.colorByPath("cyan.medium")
                },
                {
                    low: asd.v,
                    high: _.nth(deadlinesAndCycles, 3),
                    label: ard.v,
                    name: ard.name,
                    color: this.ColorService.colorByPath("cyan.medium")
                },
                {
                    low:
                        isNegativeCycle < 0
                            ? _.nth(deadlinesAndCycles, 3)
                            : apd.v,
                    high:
                        isNegativeCycle < 0
                            ? apd.v
                            : _.nth(deadlinesAndCycles, 3),
                    label: isNegativeCycle,
                    name: financialCycle.name,
                    color: this.ColorService.colorByPath("purple.medium")
                },
                {
                    low: 0,
                    high: _.nth(deadlinesAndCycles, 5),
                    label: operatingCycle.v,
                    name: operatingCycle.name,
                    color: this.ColorService.colorByPath("yellow.medium")
                }
            ];

            const element = angular.element(
                document.querySelector(".dead-line-chart")
            );

            const chart = {
                chart: {
                    width: _.get(element[0], "clientWidth"),
                    paddingTop: 0,
                    marginTop: 10,
                    marginRight: 30,
                    marginBottom: 0,
                    marginLeft: 24,
                    type: "columnrange",
                    inverted: true
                },
                title: {
                    text: ""
                },
                credits: {
                    enabled: false
                },
                exporting: {
                    enabled: false
                },
                plotOptions: {
                    stacking: "normal",
                    columnrange: {
                        dataLabels: {
                            enabled: true
                        }
                    },
                    series: { pointWidth: 50 }
                },

                legend: {
                    enabled: false
                },

                series: [
                    {
                        data,
                        dataLabels: {
                            enabled: false
                        }
                    }
                ],
                tooltip: {
                    formatter: function () {
                        const labelDay = this.point.label > 1 ? "dias" : "dia";

                        return `${this.key}: ${this.point.label.toFixed(
                            0
                        )} ${labelDay}`;
                    }
                },
                yAxis: {
                    title: "",

                    labels: {
                        formatter: function () {
                            const name = {
                                buy: 0,
                                payment: label.PMP,
                                sale: label.PME,
                                receipt: label.PMR
                            };

                            if (name.buy == this.value) return "Compra";
                            if (name.payment == this.value) return "Pagamento";
                            if (name.sale == this.value) return "Venda";
                            if (name.receipt == this.value)
                                return "Recebimento";
                        },
                        rotation: 270,
                        align: "right",
                        x: 6,
                        y: 1
                    },
                    tickPositioner: function () {
                        if (label.CF < 0)
                            deadlinesAndCycles.sort((a, b) => a - b);

                        return deadlinesAndCycles;
                    },
                    opposite: true,
                    gridLineDashStyle: "Dash"
                },
                xAxis: {
                    labels: {
                        enabled: false
                    },
                    title: {
                        text: ""
                    },
                    lineWidth: 0,
                    tickLength: 0
                }
            };

            this.visualization = { chart };
        } catch (error) {
            console.error(error);
        }
    }

    _setVisualizationComparation() {
        this.customStructure = false;
        const structure = angular.copy(ComparationStructures["columnrange"]);
        structure.series = [
            {
                _id: "dfijklegHRucwaP6edHc",
                unit: "day",
                name: "PMP",
                color: "cyan.medium"
            },
            {
                _id: "H6ZxvW9j9Ydxyq7tz",
                unit: "day",
                name: "PME",
                color: "cyan.medium"
            },
            {
                _id: "eRm54xkHHPogxewgh",
                unit: "day",
                name: "PMR",
                color: "cyan.medium"
            },
            {
                _id: "tgTdo5CkuaheS6eME",
                unit: "day",
                name: "Ciclo Financeiro",
                color: "purple.medium"
            },
            {
                _id: "cpqQ9HdHMdwYGyM34",
                unit: "day",
                name: "Ciclo Operacional",
                color: "yellow.medium"
            }
        ];

        if (this.goals && this.visualizationData?.goals?.length) {
            const goals = [];
            structure.series.forEach((serie) => {
                const goal = this.visualizationData?.goals.find(
                    (g) => g.s == serie._id
                );
                goals.push({ _id: goal.r, color: serie.color, type: "line" });
            });
            structure.goals = goals;
        }

        this.visualization = { chart: structure };
    }

    _setVisualization() {
        if (
            this.currentComparation.active ||
            this.budget ||
            this.projection ||
            this.goals
        )
            this._setVisualizationComparation();
        else this._setDefaultVisualization();
    }

    _getComparations(series) {
        this.CalculatingMachine.setSource(this.source);

        return this.CalculatingMachine.comparation({
            series,
            companyId: this.companyId,
            xFilter: this.currentPeriod,
            yFilter: this.currentComparation
        });
    }
}

ChartColumnRangeComponent.$inject = ["$stateParams", "ThemesService"];

const name = "chartColumnRangeComponent";
const def = {
    bindings: {
        series: "<",
        configs: "<",
        points: "<",
        currentPeriod: "<",
        currentComparation: "<",
        source: "<",
        budget: "<",
        projection: "<",
        goals: "<",
        visualizationData: "<"
    },
    controller: ChartColumnRangeComponent,
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
